<ng-container *ngxPermissionsOnly="'TAGS_PERMISSION'">
  <h3 class="row-tag-editor-title" translate>CONTACTS_LIST.TAGS</h3>
  <mat-form-field class="example-chip-list row-tag-editor">
    <i class="material-icons row-tag-editor-close" (click)="rowEditorExit()">close</i>
    <mat-chip-list #chipList aria-label="tag selection">
      <div class="tags-wrapper">
        <mat-chip
          *ngFor="let tag of rowTagsList"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(tag)">
          {{tag}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
      </div>

      <input
        [placeholder]="'CONTACTS_LIST.TAG_PLACEHOLDER_SECONDARY' | translate"
        #tagInput
        [formControl]="tagCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event.value, $event.input)">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let chosenTag of filteredTags | async" [value]="chosenTag"
                  (onSelectionChange)="add($event.source.value)">
        {{chosenTag}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</ng-container>
